import React from 'react'
import {useSelector} from 'react-redux'
import {getCurrencyCode} from 'modules/meta/selectors'

import {Icon} from '@vio/atlas/Icon'
import {Tag} from '@vio/atlas/Tag'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'
import {VioTagDetails} from '@vio/core/src/tag/types'
import {VioDealTag} from '@vio/shared/src/privateDeal/VioDealTag'

const PRIMARY_ROOM_OFFER_TAG_DATA_ID = 'primaryRoomOfferTag'

interface Props {
  isSelected: boolean
  vioTagDetails: VioTagDetails
  brandName: string
}

export const PrimaryRoomOfferTag = ({
  isSelected,
  vioTagDetails,
  brandName
}: Props) => {
  const currencyCode = useSelector(getCurrencyCode)
  const {
    isVioTagVisible,
    savingType,
    savingPrice,
    savingPercentage,
    tagMessage
  } = vioTagDetails

  if (isSelected)
    return (
      <Tag
        variant="success"
        iconStart={<Icon name="ArrowDown" size="sm" />}
        dataId={PRIMARY_ROOM_OFFER_TAG_DATA_ID}
      >
        <FormattedMessageWrapper
          id="yourSelection"
          defaultMessage="Your selection"
        />
      </Tag>
    )

  if (isVioTagVisible && tagMessage) {
    return (
      <VioDealTag
        savingPercentage={savingPercentage}
        message={{...tagMessage, values: {brandName}}}
        savingType={savingType}
        savingPrice={savingPrice}
        currencyCode={currencyCode}
        dataId={PRIMARY_ROOM_OFFER_TAG_DATA_ID}
      />
    )
  }
  return null
}
